import Vue from 'vue';
import { ActivityIcon, AlertTriangleIcon, ArchiveIcon, ArrowRightIcon, ArrowUpLeftIcon, AwardIcon, BarChartIcon, BellIcon, BookIcon, BookmarkIcon, BookOpenIcon, CheckIcon, CheckCircleIcon, ChevronDownIcon, ChevronRightIcon, ChevronUpIcon, CircleIcon, ClipboardIcon, ClockIcon, CloudRainIcon, CodeIcon, CopyIcon, CornerRightDownIcon, DollarSignIcon, DownloadIcon, DropletIcon, EditIcon, Edit3Icon, ExternalLinkIcon, EyeIcon, FeatherIcon, FileIcon, FileTextIcon, FilmIcon, FilterIcon, FlagIcon, GlobeIcon, HeartIcon, HelpCircleIcon, HomeIcon, InfoIcon, LayersIcon, LayoutIcon, LifeBuoyIcon, LinkIcon, LockIcon, LogOutIcon, MailIcon, MaximizeIcon, MenuIcon, MoonIcon, MoreVerticalIcon, MousePointerIcon, PackageIcon, PieChartIcon, PlusCircleIcon, RepeatIcon, SearchIcon, SettingsIcon, ShareIcon, SidebarIcon, SlidersIcon, SmartphoneIcon, SmileIcon, SunIcon, SunsetIcon, ToolIcon, Trash2Icon, TrendingUpIcon, TruckIcon, TvIcon, TypeIcon, UserIcon, UserPlusIcon, UsersIcon, XIcon, XCircleIcon, ZapIcon, } from '@inip/vue-feather-icons';
export function initFeather() {
    Vue.component('ActivityIcon', ActivityIcon);
    Vue.component('AlertTriangleIcon', AlertTriangleIcon);
    Vue.component('ArchiveIcon', ArchiveIcon);
    Vue.component('ArrowRightIcon', ArrowRightIcon);
    Vue.component('ArrowUpLeftIcon', ArrowUpLeftIcon);
    Vue.component('AwardIcon', AwardIcon);
    Vue.component('BarChartIcon', BarChartIcon);
    Vue.component('BellIcon', BellIcon);
    Vue.component('BookIcon', BookIcon);
    Vue.component('BookmarkIcon', BookmarkIcon);
    Vue.component('BookOpenIcon', BookOpenIcon);
    Vue.component('CheckIcon', CheckIcon);
    Vue.component('CheckCircleIcon', CheckCircleIcon);
    Vue.component('ChevronDownIcon', ChevronDownIcon);
    Vue.component('ChevronRightIcon', ChevronRightIcon);
    Vue.component('ChevronUpIcon', ChevronUpIcon);
    Vue.component('CircleIcon', CircleIcon);
    Vue.component('ClipboardIcon', ClipboardIcon);
    Vue.component('ClockIcon', ClockIcon);
    Vue.component('CloudRainIcon', CloudRainIcon);
    Vue.component('CodeIcon', CodeIcon);
    Vue.component('CopyIcon', CopyIcon);
    Vue.component('CornerRightDownIcon', CornerRightDownIcon);
    Vue.component('DollarSignIcon', DollarSignIcon);
    Vue.component('DownloadIcon', DownloadIcon);
    Vue.component('DropletIcon', DropletIcon);
    Vue.component('EditIcon', EditIcon);
    Vue.component('Edit3Icon', Edit3Icon);
    Vue.component('ExternalLinkIcon', ExternalLinkIcon);
    Vue.component('EyeIcon', EyeIcon);
    Vue.component('FeatherIcon', FeatherIcon);
    Vue.component('FileIcon', FileIcon);
    Vue.component('FileTextIcon', FileTextIcon);
    Vue.component('FilmIcon', FilmIcon);
    Vue.component('FilterIcon', FilterIcon);
    Vue.component('FlagIcon', FlagIcon);
    Vue.component('GlobeIcon', GlobeIcon);
    Vue.component('HeartIcon', HeartIcon);
    Vue.component('HelpCircleIcon', HelpCircleIcon);
    Vue.component('HomeIcon', HomeIcon);
    Vue.component('InfoIcon', InfoIcon);
    Vue.component('LayersIcon', LayersIcon);
    Vue.component('LayoutIcon', LayoutIcon);
    Vue.component('LifeBuoyIcon', LifeBuoyIcon);
    Vue.component('LinkIcon', LinkIcon);
    Vue.component('LockIcon', LockIcon);
    Vue.component('LogOutIcon', LogOutIcon);
    Vue.component('MailIcon', MailIcon);
    Vue.component('MaximizeIcon', MaximizeIcon);
    Vue.component('MenuIcon', MenuIcon);
    Vue.component('MoonIcon', MoonIcon);
    Vue.component('MoreVerticalIcon', MoreVerticalIcon);
    Vue.component('MousePointerIcon', MousePointerIcon);
    Vue.component('PackageIcon', PackageIcon);
    Vue.component('PieChartIcon', PieChartIcon);
    Vue.component('PlusCircleIcon', PlusCircleIcon);
    Vue.component('RepeatIcon', RepeatIcon);
    Vue.component('SearchIcon', SearchIcon);
    Vue.component('SettingsIcon', SettingsIcon);
    Vue.component('ShareIcon', ShareIcon);
    Vue.component('SidebarIcon', SidebarIcon);
    Vue.component('SlidersIcon', SlidersIcon);
    Vue.component('SmartphoneIcon', SmartphoneIcon);
    Vue.component('SmileIcon', SmileIcon);
    Vue.component('SunIcon', SunIcon);
    Vue.component('SunsetIcon', SunsetIcon);
    Vue.component('ToolIcon', ToolIcon);
    Vue.component('Trash2Icon', Trash2Icon);
    Vue.component('TrendingUpIcon', TrendingUpIcon);
    Vue.component('TruckIcon', TruckIcon);
    Vue.component('TvIcon', TvIcon);
    Vue.component('TypeIcon', TypeIcon);
    Vue.component('UserIcon', UserIcon);
    Vue.component('UserPlusIcon', UserPlusIcon);
    Vue.component('UsersIcon', UsersIcon);
    Vue.component('XIcon', XIcon);
    Vue.component('XCircleIcon', XCircleIcon);
    Vue.component('ZapIcon', ZapIcon);
}
